module.exports = __webpack_public_path__ + "static/fonts/Arimo-Bold.a0ffdc0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/arimo/Arimo-Bold.ttf
// module id = 570
// module chunks = 9